module.exports = __webpack_public_path__ + "static/img/capsule.5d055704.png";